import { Injectable } from "@angular/core";

/** @deprecated - just use the native `console` functions. */
@Injectable()
export class LoggingService
{
    /** @deprecated - just use the native `console` functions. */
    error(message: string, data?: unknown, summary?: string): void
    {
        console.error(this.format(`ERROR: ${message}`, `Summary: ${summary}`, `Details: ${data}`));
    }

    private format(message: string, data?: unknown, summary?: string): string
    {
        return JSON.stringify(
            {
                message,
                data,
                summary,
            },
            null,
            4
        );
    }

    /** @deprecated - just use the native `console` functions. */
    info(message: string, data?: unknown, summary?: string): void
    {
        console.info(this.format(message, `Summary: ${summary}`, `Details: ${data}`));
    }

    /** @deprecated - just use the native `console` functions. */
    log(...args: Array<unknown>): void
    {
        console.log(args);
    }

    /** @deprecated - just use the native `console` functions. */
    success(message: string, data?: unknown, summary?: string): void
    {
        console.info(this.format(`Success: ${message}`, `Summary: ${summary}`, `Details: ${data}`));
    }

    /** @deprecated - just use the native `console` functions. */
    warning(message: string, data?: unknown, summary?: string): void
    {
        console.warn(this.format(`Warning: ${message}`, `Summary: ${summary}`, `Details: ${data}`));
    }
}
